export function joinBaseUrl(baseURL = '', url = ''): string {
  if (!baseURL || /^https?:\/\//i.test(url)) {
    return url
  }

  return `${baseURL.replace(/\/+$/, '')}/${url.replace(/^\/+/, '')}`
}

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '))
  } catch {
    return value
  }
}

export function parseQueryString(query = ''): Record<string, string> {
  const result: Record<string, string> = {}
  const normalized = query.replace(/^[?#]/, '')

  if (!normalized) {
    return result
  }

  normalized.split('&').forEach((part) => {
    if (!part) return

    const separatorIndex = part.indexOf('=')
    const rawKey = separatorIndex === -1 ? part : part.slice(0, separatorIndex)
    const rawValue = separatorIndex === -1 ? '' : part.slice(separatorIndex + 1)
    const key = safeDecode(rawKey)

    if (key) {
      result[key] = safeDecode(rawValue)
    }
  })

  return result
}

export function parseUrlParams(url?: string): Record<string, string> {
  if (!url) {
    return {}
  }

  const result: Record<string, string> = {}
  const [mainUrl, hashPart] = String(url).split('#')
  const queryIndex = mainUrl.indexOf('?')

  if (queryIndex !== -1) {
    Object.assign(result, parseQueryString(mainUrl.slice(queryIndex + 1)))
  }

  if (hashPart) {
    const hashQueryIndex = hashPart.indexOf('?')
    if (hashQueryIndex !== -1) {
      Object.assign(result, parseQueryString(hashPart.slice(hashQueryIndex + 1)))
    }
  }

  return result
}

export function hasUrlParam(url: string, paramName: string): boolean {
  return Object.prototype.hasOwnProperty.call(parseUrlParams(url), paramName)
}

export function stringifyQueryParams(params: Record<string, unknown>): string {
  return Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join('&')
}
